<template >
  <div class="flex justify-center items-center">
    <div class="error-message" v-html="lang.error"></div>
  </div>
</template>

<script>
export default {
  props: {
    lang: Object,
  },
  name: "Error",
  mounted() {},
};
</script>

<style scoped>

</style>
